import Dialog from '@stimulus-components/dialog'
import { hasCookie, writeFlagCookie } from 'javascripts/common/cookie'

// 募集更新モーダルの表示制御と表示済みの記録。
// モーダルを表示したら Cookie を記録し、抑制期間は再表示しない。
// Cookie キーと抑制期間は Ruby 定数（RecruitUpdateModalRenderable）を正とし、erb 経由で受け取る。

export default class extends Dialog {
  static values = {
    seenCookieKey: String,
    suppressionMaxAgeDays: Number,
    variant: String,
  }

  get dialogTarget() {
    return this.element
  }

  connect() {
    super.connect() // 基底クラスの turbo:before-render でのダイアログ強制クローズを登録する

    if (this.#suppressed()) return
    if (document.documentElement.hasAttribute('data-turbo-preview')) return // キャッシュプレビュー中は cookie を記録しない

    this.element.showModal()
    this.element.focus() // 自動フォーカスによる青いフォーカスリングを避け dialog 自身へ移す
    this.#remember()
    this.#pushEvent('recruit_update_modal_view')
  }

  // Escキー押下時（<dialog> の cancel イベント）。
  cancelClose(event) {
    event.preventDefault()
    this.close()
  }

  // 一括更新ボタン送信押下。モーダルのUI誘導効果（クリックが発生するか）を計測する。
  trackBulkContinue() {
    this.#pushEvent('recruit_update_modal_bulk_continue')
  }

  // 「募集を新規作成・変更・停止する」リンク押下。
  trackManageClick() {
    this.#pushEvent('recruit_update_modal_manage_click')
  }

  #suppressed() {
    return hasCookie(this.seenCookieKeyValue)
  }

  // 表示済みフラグを Cookie に記録する（抑制期間で自然失効）
  #remember() {
    writeFlagCookie(this.seenCookieKeyValue, { maxAge: this.suppressionMaxAgeDaysValue * 24 * 60 * 60 })
  }

  // 全イベントにvariant（all/mixed/none）を自動付与する。variant単位でボタンも一意に決まる想定。
  #pushEvent(eventName, params = {}) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: eventName, variant: this.variantValue, ...params })
  }
}
